import React, { Component } from 'react'
import {
    useParams
} from "react-router-dom";
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

import CircularProgress from '@material-ui/core/CircularProgress';


import connect from "react-redux/es/connect/connect";
import EtapaFoto from "./EtapaFoto";


const styles = theme => ({
    dashboardCardSection: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1) * 8
    },
    newServiceOrderTooltip: {
        position: 'fixed',
        top: '90vh',
        right: '2vh',
    },
    leftMargin: {
        marginLeft: theme.spacing(1)
    },
    button: {
        margin: theme.spacing(1)
    },
    infoIcon: {
        verticalAlign: "middle"
    },
    progress: {
        margin: theme.spacing(1) * 2,
    },
    relative: {
        position: 'relative'
    },
    formControl: {
        marginRight: theme.spacing(1),
        minWidth: theme.spacing(1) * 10,
    },
    textCenter: {
        textAlign: 'center'
    },
    marginChart: {
        marginBottom: '20px'
    }
});

class EtapaCardList extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }


    };

    componentDidMount() {
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
    }

    render() {
        const { isLoading } = this.props;

        if ( !this.props.ordemServico.fotografiaPlanta.situacaoAtual ||   this.props.ordemServico.fotografiaPlanta.situacaoAtual.length == 0) { return (<React.Fragment/>)}

         console.log("FOTO",this.props.ordemServico.fotografiaPlanta);

        let etapasArray = [];
        this.props.ordemServico.fotografiaPlanta.situacaoAtual.map( os => {
            // console.log("tempo de espera", os.ordemServicoId, new Date(),  new Date(os.DTUltimaEtapa),  (new Date().getTime() - new Date(os.DTUltimaEtapa).getTime()) / 1000  )
           let ix = etapasArray.findIndex( e => e.estabelecimentoId === os.estabelecimentoId && e.etapaAtual === os.etapaAtual );
           if (ix < 0) {
               etapasArray.push({
                   ...os,

                   quantidadeOS : 1,
                   os: [os],
                   concluidos: 0,
                   tempoTotalEspera: (os.DTUltimaEtapa && new Date(os.DTUltimaEtapa).getFullYear() > 2000)  ?
                                          ((new Date().getTime() - new Date(os.DTUltimaEtapa).getTime())  )  : 0
               })
           } else {

               etapasArray[ix].quantidadeOS = etapasArray[ix].quantidadeOS + 1;
               etapasArray[ix].tempoTotalEspera =
                   (os.DTUltimaEtapa && new Date(os.DTUltimaEtapa).getFullYear() > 2000) ? ((etapasArray[ix].tempoTotalEspera? etapasArray[ix].tempoTotalEspera : 0) + (new Date().getTime() - new Date(os.DTUltimaEtapa).getTime())  )  :
                                      (etapasArray[ix].tempoTotalEspera? etapasArray[ix].tempoTotalEspera : 0);
               etapasArray[ix].os.push(os);
           }
        });
        // console.log("FOTO ETAPAS 1", etapasArray);


        this.props.ordemServico.fotografiaPlanta.qtdeConcluidasPorEtapa.map( q => {
           let ix = etapasArray.findIndex( e=> e.estabelecimentoId === q.estabelecimentoId && e.etapaId === q.etapaId  );
            if (ix < 0) {
                etapasArray.push({
                    ...q,
                    quantidadeOS : 0,
                    os: [],
                    concluidos: q.quantidadeConcluidas,
                    tempoTotalEspera: 0
                })
            } else {
                etapasArray[ix].concluidos =  etapasArray[ix].concluidos  + q.quantidadeConcluidas;
            }
        });

        etapasArray.sort(function (a, b) {
            var aSize = a.estabelecimentoId;
            var bSize = b.estabelecimentoId;
            var aLow = a.etapaId; //sequencia ; // a.etapaId
            var bLow = b.etapaId ; // b.etapaId;
            // console.log(aLow + " | " + bLow);

            if(aSize == bSize)
            {
                return (aLow < bLow) ? -1 : (aLow > bLow) ? 1 : 0;
            }
            else
            {
                return (aSize < bSize) ? -1 : 1;
            }
        });


        // console.log("FOTO ETAPAS 2", etapasArray);

        return (
            <React.Fragment>
                { etapasArray
                    .filter(e => e.ehNaoVisivel === 0)
                    .map( (e, ix) => {

                    return (<EtapaFoto key={ix} foto={e} index={ix}/> );
                }) }
            </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {

        ordemServico: state.ordemServicoReducer

    }
}

export default  connect(mapStateToProps, {  })((withStyles(styles, {withTheme: true}))(EtapaCardList));
